import * as moment from 'moment';
import { STATUSES } from './constants';

export const cutTrailingSlash = pathname => pathname.replace(/\/$/, '');

export const getExcerpt = (status, excerpt) => {
  if (status === 'decline') {
    return 'Declined';
  }
  if (status === 'accept') {
    return 'Accepted';
  }
  return excerpt;
};

export const getExcerptTL = (item, MESSAGE_TYPES) => {
  // if (item.type.id === MESSAGE_TYPES.decline.id) {
  //   return item.excerpt ? item.excerpt : 'Declined';
  // }
  // if (item.type.id === MESSAGE_TYPES.invite.id) {
  //   return 'Accepted';
  // }
  return item.excerpt;
};

export const statusCode = status => {
  switch (status) {
    case STATUSES.notStarted.name:
      return STATUSES.notStarted.value;
    case STATUSES.inProgress.name:
      return STATUSES.inProgress.value;
    case STATUSES.completed.name:
      return STATUSES.completed.value;
    case STATUSES.locked.name:
      return STATUSES.locked.value;
    default:
      return STATUSES.notStarted.value;
  }
};

export const convertTime = time => moment(time).format('MM.DD.YY');
export const convertTimeToAgo = time => moment(time).fromNow();
export const convertTimeClock = time => moment(time).format('LT');
export const convertForWebinar = time => moment(time)

export const calculateCurrentTabIndex = (routesArr, pathName) => {
  const currentTab = routesArr.find(route => route.path === pathName);
  return routesArr.indexOf(currentTab);
};

export const firstLetters = value =>
  value.length === 2 ? value : `${value.split(' ')[0][0]}${value.split(' ')[1][0]}`.toUpperCase();
export const routesAfterLogin = (routes, excludeArr) =>
  routes.filter(route => !excludeArr.includes(route.path));

export const getSelectedProgram = (selectedProgramId, programList) =>
  programList.list !== null &&
  programList.list.filter(el => el.programId === parseFloat(selectedProgramId))[0];

export const getSelectedModule = (selectedModuleId, moduleList) =>
  moduleList.list !== null &&
  moduleList.list.filter(el => el.moduleId === parseFloat(selectedModuleId))[0];

export const getSelectedContent = (moduleContent, contentId) =>
  moduleContent.content &&
  moduleContent.content.filter(el => parseFloat(el.contentId) === parseFloat(contentId))[0];

export const getLatestVersionIdPath = versions => {
  if (versions) {
    const versionDate = versions.reduce(
      (max, version) =>
        moment(version.dateUpdated).format('YYYY-MM-DD') > moment(max).format('YYYY-MM-DD')
          ? version.dateUpdated
          : max,
      0,
    );
    return versions.find(version => version.dateUpdated === versionDate).path;
  }
  return false;
};

export const getStartAgainPath = moduleContent =>
  moduleContent.content &&
  moduleContent.content.find(content => content.contentId === moduleContent.selectedContentId).path;

export const getFileType = type => {
  switch (type) {
    case 'plain/text':
      return 'text';
    case 'image/jpeg':
    case 'image/png':
      return 'image';
    case 'application/pdf':
      return 'pdf';
    case 'video/mp4':
      return 'video';
    default:
      return 'file';
  }
};



// WEBPACK FOOTER //
// ./src/utils.js